import React, { useCallback, useContext, useEffect, useState } from 'react'
import '../../../styles/devotionalTithi.css'
import { BsArrowRightSquareFill, BsFillArrowLeftSquareFill } from "react-icons/bs";
import Skeleton from '../../pages/skelton';
import DevotionalBreadCrumb from '../devotionalBreadCrumb';
import { Helmet } from 'react-helmet-async';
import { DeviceContext } from '..';
import PageAds from '../../common/pageAds';

const DevotionalTithi = ({ data : initData}) => {

              const ssrData = initData?.[0]?.tithiPage || {}
              const ssrTithiData = ssrData?.tithiPageData || null
              const ssrTithiDataError = ssrData?.tithiPageDataError || null
              const ssrYear = ssrData?.year  || null
              const ssrMonth = ssrData?.month || null

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(ssrYear || currentYear);
  const [selectedMonth, setSelectedMonth] = useState(ssrMonth || String(new Date().getMonth() + 1).padStart(2, '0'));
  const [headYear, setHeaderYear] = useState(ssrYear || currentYear);
  const [headerMonth, setHeaderMonth] = useState('');
  const [data, setData] = useState(ssrTithiData);
  const [loading, setLoading] = useState(!ssrTithiData); 
  const [error, setError] = useState(null);
  const {mobile,setMobile,containerRef} = useContext(DeviceContext)

  const startYear = 2014;
  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => currentYear - i);

  const months = [
    { text: "January", value: "01" },
    { text: "February", value: "02" },
    { text: "March", value: "03" },
    { text: "April", value: "04" },
    { text: "May", value: "05" },
    { text: "June", value: "06" },
    { text: "July", value: "07" },
    { text: "August", value: "08" },
    { text: "September", value: "09" },
    { text: "October", value: "10" },
    { text: "November", value: "11" },
    { text: "December", value: "12" }
  ];

  const updateHeader = (monthVal, yearVal) => {
    setHeaderYear(yearVal);
    setHeaderMonth(months.find(m => m.value === monthVal)?.text || '');
  };

  const getData = useCallback(async (month = selectedMonth, year = selectedYear) => {
    try {
    
      setData(null);
      setHeaderYear('');
      setHeaderMonth('');

      const resp = await fetch(`https://www.teluguone.com/devotional/devotionalSelectTithiDetailsJson.php?month=${month}&year=${year}`);
      if (!resp.ok) throw new Error(`Response was not ok`);

      const json = await resp.json();
      updateHeader(month, year);

     
        setData(json.devotional_tithi_details);
        setLoading(false);
        setError(null);
         setLoading(false)
    } catch (err) {
      setData(null);
      setLoading(false);
      setError(err.message);
      console.error(`Error: ${err.message}`);
    }
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    if (!ssrTithiData) {
      setLoading(true)
      getData();
    } else {
      updateHeader(selectedMonth, selectedYear);
    }

  }, []);

  const prevTithi = () => {
    let newMonth = selectedMonth;
    let newYear = selectedYear;

    if (selectedMonth === '01') {
      newYear = String(Number(selectedYear) - 1);
      newMonth = '12';
    } else {
      newMonth = String(Number(selectedMonth) - 1).padStart(2, '0');
    }

    setSelectedYear(newYear);
    setSelectedMonth(newMonth);
   getData(newMonth, newYear)
  };

  const nxtTithi = () => {
    let newMonth = selectedMonth;
    let newYear = selectedYear;

    if (selectedMonth === '12') {
      newYear = String(Number(selectedYear) + 1);
      newMonth = '01';
    } else {
      newMonth = String(Number(selectedMonth) + 1).padStart(2, '0');
    }

    setSelectedYear(newYear);
    setSelectedMonth(newMonth);
    getData(newMonth, newYear)
  };

  if (loading ) {
    return (
      <div className='container-fluid devotional-tithi g-0'>
        <div className='row g-0'>
          {Array(10).fill(null).map((_, i) => (
            <div key={i} className="col-4 col-sm-3">
              <Skeleton type={"square"} />
              <Skeleton type={"title"} />
            </div>
          ))}
        </div>
        <div className='row g-0'>
          {Array(8).fill(null).map((_, i) => (
            <div key={i} className="col-6 col-sm-4 col-md-3">
              <Skeleton type={"square"} />
              <Skeleton type={"title"} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='devotional-tithi g-0 container-fluid'>
        <div className='row g-0'>
          <div className="col-12">
            <div className="json-loading-error-div">
              <img src="/devotional/assets/images/json_error.png" alt="json_error" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='container-fluid devotional-tithi g-0'>

          <Helmet><title>Telugu Tithi Calendar | Panchangam | Daily Tithi | Telugu Festivals | TeluguOne Devotional</title></Helmet>     
      <div className='row g-0'>
        <DevotionalBreadCrumb breadCrumb="Tithi Archives" />

        <div className='col-12 devotional-tithi-search-container'>
          <label htmlFor='tithiYear'>Year</label>
          <select id="tithiYear" onChange={(e) => setSelectedYear(e.target.value)}>
            <option>Select Year</option>
            {years.map((item, i) => <option key={i}>{item}</option>)}
          </select>

          <label htmlFor='tithiMonth'>Month</label>
          <select id="tithiMonth" onChange={(e) => setSelectedMonth(e.target.value)}>
            <option>Select Month</option>
            {months.map((item, i) => (
              <option key={i} value={item.value}>{item.text}</option>
            ))}
          </select>

          <button type='button' className='btn btn-primary' onClick={() => getData()}>View</button>
        </div>

        <div className='col-12 devotional-tithi-main-title'>{headerMonth} - {headYear}</div>

          <div className='col-12 d-flex justify-content-between devotional-tithi-arrows-container'>
          <BsFillArrowLeftSquareFill className='devotional-tithi-arrow' onClick={prevTithi} />
          <BsArrowRightSquareFill className='devotional-tithi-arrow' onClick={nxtTithi} />
        </div>

        {Array.isArray(data) && !data?.[0]?.msg ? data.map((item, index) => (
          <div className='col-12 col-sm-6 col-md-4 position-relative dtc-parent' key={index}>
            <div className='devotional-tithi-card shadow-lg' dangerouslySetInnerHTML={{ __html: item.tithi_data ? item.tithi_data : '' }} />
            <div className='devotional-tithi-overlay-card'>{item.cdate ? item.cdate : ''}</div>
          </div>
        ))    : Array.isArray(data) && data?.[0]?.msg ?  <div className='col-12 position-relative dtc-parent' >
                    <div className='devotional-tithi-card shadow-lg text-center justify-content-center align-items-center' >
                         No Data Found
                    </div>       
                   </div> : ''}

        <div className='col-12 d-flex justify-content-between devotional-tithi-arrows-container'>
          <BsFillArrowLeftSquareFill className='devotional-tithi-arrow' onClick={prevTithi} />
          <BsArrowRightSquareFill className='devotional-tithi-arrow' onClick={nxtTithi} />
        </div>
      </div>

        <PageAds mobile={mobile} containerRef={containerRef} />
    </div>
  );
};

export default DevotionalTithi;
